var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verk-item-list pa-2"},[_c('ApiSearchPage',{attrs:{"url":_vm.url,"columns":_vm.columns,"name":_vm.apiSearchName,"hasPager":false,"search":false,"resetFilter":false,"resetSort":false,"refresh":false,"tableColPadding":6,"displayTitles":true},scopedSlots:_vm._u([{key:"disabledText",fn:function(ref){
var column = ref.column;
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item[column.field]))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }